var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 35,
    viewBox: "0 0 59 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0948 23.6082V2.49268H27.0839V23.6082C27.0839 29.8808 21.9991 34.966 15.7261 34.966H11.105C4.97179 34.966 0 29.9942 0 23.8613C0 17.7277 4.97179 12.7563 11.105 12.7563H11.7948V19.7454H11.105C8.83188 19.7454 6.98917 21.5881 6.98917 23.8613C6.98917 26.1341 8.83188 27.9768 11.105 27.9768H15.7261C18.1387 27.9768 20.0948 26.0211 20.0948 23.6085V23.6082Z",
    fill: "#002F56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3944 23.4621V2.49396H35.3836V23.4621C35.3836 25.8747 37.3393 27.8308 39.7522 27.8308H57.9542V34.8203H39.7522C33.4796 34.8203 28.3944 29.7351 28.3944 23.4621Z",
    fill: "#002F56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.163 3.54073C52.163 5.49615 50.578 7.08145 48.6223 7.08145C46.6668 7.08145 45.0815 5.49648 45.0815 3.54073C45.0815 1.5853 46.6665 0 48.6223 0C50.5777 0 52.163 1.5853 52.163 3.54073Z",
    fill: "#00848D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9404 15.7018L43.5823 9.88562C41.2149 11.497 39.6171 14.1547 39.4539 17.1938H46.2341C46.3132 16.622 46.567 16.1059 46.9401 15.7015L46.9404 15.7018Z",
    fill: "#00848D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7129 14.912L53.014 9.19436C51.7692 8.59089 50.3721 8.25241 48.8955 8.25241C47.3564 8.25241 45.9032 8.62056 44.6188 9.2728L47.9331 15.0132C48.2538 14.883 48.6045 14.8111 48.972 14.8111C49.2284 14.8111 49.4769 14.8464 49.7129 14.9117V14.912Z",
    fill: "#00848D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6798 17.0178H58.3259C58.1074 13.9899 56.4634 11.3578 54.0617 9.78799L50.7751 15.4806C51.2293 15.8718 51.5549 16.4084 51.6798 17.0181V17.0178Z",
    fill: "#00848D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8955 27.1632C53.9454 27.1632 58.0701 23.2049 58.3368 18.2216H51.6597C51.3687 19.4361 50.2758 20.3388 48.972 20.3388C47.7321 20.3388 46.6827 19.5221 46.3326 18.3976H39.4651C39.8184 23.2975 43.9052 27.1629 48.8955 27.1629V27.1632Z",
    fill: "#002F56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3186cfcd810127789766970a508b29cf.svg";
export { ForwardRef as ReactComponent };